<template>
    <div>
        <div class="form-group">
            <label class="font-weight-bold">
                {{ __('orders.shipping.provider') }}
            </label>
            <input type="text"
                   class="form-control form-control-solid"
                   placeholder="DHL, UPS, ..."
                   v-model="form.shipping.provider"
            >
            <div class="form-text text-muted">
                {{ __('orders.shipping.enter_provider_name') }}
            </div>
            <FormErrors :error="form.errors['shipping.provider']"/>
        </div>
        <div class="form-group">
            <label class="font-weight-bold">
                {{ __('orders.shipping.tracking_code') }}
            </label>
            <input type="text"
                   class="form-control form-control-solid"
                   placeholder="..."
                   v-model="form.shipping.tracking_code"
            >
            <div class="form-text text-muted">
                {{ __('orders.shipping.enter_optional_tracking_code') }}
            </div>
            <FormErrors :error="form.errors['shipping.tracking_code']"/>
        </div>
        <div class="d-flex flex-row">
            <div class="flex-grow-1">
                <button class="btn btn-success"
                        :disabled="form.shipping.provider.length === 0"
                        @click="submitShippingDetails">
                    <i class="fas fa-paper-plane"/>
                    {{ __('actions.order.transition_to.send') }}
                </button>
            </div>
            <div>
                <button class="btn btn-default btn-hover-danger"
                        @click="$emit('transition', OrderState.Send)">
                    <i class="fa fa-arrow-right"/>
                    {{ __('orders.shipping.continue_without_details') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import FormErrors from "@components/Form/FormErrors.vue";
import {OrderState} from "@composables/orderStates";

export default {
    components: {FormErrors},

    props: {
        order: Object,
        store: Object
    },

    data() {
        return {
            form: this.$inertia.form({
                to_state: OrderState.Send,
                shipping: {
                    provider: '',
                    tracking_code: null
                }
            })
        }
    },

    methods: {
        submitShippingDetails() {
            this.form.patch(this.$route('order.state', [this.store.id, this.order.url_key]));
        },
    },

    computed: {
        OrderState() {
            return OrderState
        }
    },
}
</script>
